import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
/**
 * 在vue单文件组件内部
 * 调用方法的方式: this.$store.commit('mutations里面的方法名称')
 * 获取全局变量的值: this.$store.state.变量路径
 */
export default createStore({
  state: {
    events: {
      closeMaskState: false,
      singleBoxState: false,
      searchTypeValueAndLabelState: false,
      searchKeyValueState: false,
      showImageModalState: false,
      showImageState: false
    },
    pageBg: {
      imgOne: true,
      imgTwo: false
    },
    globalObj: {
      nowUserLoginState: false,
      searchType: '',
      searchKeyWords: '',
      showImgID: '',
      showImgInfo: '',
      checkUserLoginStateIntervalAddr: 1,
      maker: '',
      publishTime: '',
      swImgs: [],
      pos: 0,

      scrollTop: 0, // 滑块位置
      totalPage: 0,
      currPageNo: 0,
      totalResult: 0
    }
  },
  mutations: {
    flipCloseMaskState (state) {
      state.events.closeMaskState = !state.events.closeMaskState
    },
    flipSingleBoxState (state) {
      state.events.singleBoxState = !state.events.singleBoxState
    },
    flipSearchTypeValueAndLabelState (state) {
      state.events.searchTypeValueAndLabelState = !state.events.searchTypeValueAndLabelState
    },
    flipSearchKeyValueState (state) {
      state.events.searchKeyValueState = !state.events.searchKeyValueState
    },
    flipShowImageModalState (state) {
      state.events.showImageModalState = !state.events.showImageModalState
    },
    flipShowImageState (state) {
      state.events.showImageState = !state.events.showImageState
    },
    setIndexViewBackgroundImgState (state, payload) {
      const { imgOneValue, imgTwoValue } = payload
      state.pageBg.imgOne = imgOneValue
      state.pageBg.imgTwo = imgTwoValue
    },
    setGlobalObjOfNowUserLoginState (state, value) {
      state.globalObj.nowUserLoginState = value
      if (value === false) {
        console.log('退出后自动清理登录检测定时器')
        clearInterval(state.globalObj.checkUserLoginStateIntervalAddr)
      }
    },
    setGlobalObjOfSearchType (state, value) {
      state.globalObj.searchType = value
    },
    setGlobalObjOfSearchKeyWords (state, value) {
      state.globalObj.searchKeyWords = value
    },
    setGlobalObjOfShowImgID (state, value) {
      state.globalObj.showImgID = value
    },
    setGlobalObjOfShowImgInfo (state, value) {
      state.globalObj.showImgInfo = value
    },

    setGlobalObjOfMaker (state, value) {
      state.globalObj.maker = value
    },

    setGlobalSearchResult (state, value) {
      state.globalObj.swImgs = value
    },

    setGlobalPublishTime (state, value) {
      state.globalObj.publishTime = value
    },

    setGlobalSwImgsPos (state, value) {
      state.globalObj.pos = value
    },
    setGlobalScrollTop (state, value) {
      state.globalObj.scrollTop = value
    },
    setGlobalTotalPage (state, value) {
      state.globalObj.totalPage = value
    },
    setGlobalCurrPageNo (state, value) {
      state.globalObj.currPageNo = value
    },
    setGlobalTotalResult (state, value) {
      state.globalObj.totalResult = value
    },
    setGlobalObjOfCheckUserLoginStateIntervalAddr (state, value) {
      state.globalObj.checkUserLoginStateIntervalAddr = value
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState()] // Vuex持久化插件: https://www.jb51.net/article/159788.htm   (使用默认localstorage keyName=vuex)
})
